export const dataProperties: { [key: string]: string } = {
  title: 'title',
  assetType: 'assetType',
  eykdlicensestatus: 'licenseStatus',
  eykdcontacts: 'contacts',
  excerpt: 'dataDescription',
  eykdlastupdateddate: 'lastUpdatedDate',
  eykdcategory: 'dataCategory',
  eykdgeoscope: 'geoScope',
  eykdserviceline: 'dataServiceLine',
  eykdsector: 'dataSector',
  vertical: 'vertical',
  contentType: 'contentType',
  Path: 'url',
  contentAge: 'contentAge',
  sortDate: 'sortDate',
  Rank: 'rank',
  eykdDescription: 'eykddescription',
  eykdLearningMaterials: 'eykdlearningmaterials',
  eykdSupport: 'eykdsupport',
  ESC_EYAEMID: 'ESC_EYAEMID',
  ESC_EYKDASSETTYPE:'ESC_EYKDASSETTYPE',
  ESC_EYKDLICENSESTATUS:'ESC_EYKDLICENSESTATUS',
  escbase_datastoretypename:'escbase_datastoretypename',
  ESC_EYKDDESCRIPTION:"ESC_EYKDDESCRIPTION"
};

export { dataProperties as DataViewModel };
